/**
 * Display helpers for the Investor workspace. Backend values are never
 * renamed — only given a human label for display.
 */
export function humanize(value) {
  if (!value) return '—';
  return String(value)
    .toLowerCase()
    .split('_')
    .map((part) => (part ? part.charAt(0).toUpperCase() + part.slice(1) : part))
    .join(' ');
}

export function orgTypeLabel(orgType) {
  const value = String(orgType || '').toLowerCase();
  if (value === 'originator') return 'Originator';
  if (value === 'provider') return 'Provider';
  if (value === 'custodian') return 'Custodian';
  if (value === 'investor') return 'Investor';
  return orgType || '—';
}

export function actorLabel(row) {
  if (!row) return '—';
  return row.actor_name || row.actor_email || (row.actor_id ? 'User' : 'System');
}

export const PACKAGE_STATUS_OPTIONS = [
  { value: '', label: 'All statuses' },
  { value: 'DRAFT', label: 'Draft' },
  { value: 'SUBMITTED', label: 'Submitted' },
  { value: 'CLASSIFIED', label: 'Classified' },
  { value: 'CERTIFIED', label: 'Certified' },
];
